import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-folder-ops",
  "use": "icon-leo-folder-ops-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-folder-ops\">\r\n<g transform=\"translate(-176.128 -176.128) scale(1.344000)\">\r\n<path d=\"M192 224h640v576H192V224zm96 96v384h448V320H288z\" />\r\n  <path d=\"M384 416h64v192h-64V416zm96 64h64v128h-64V480zm96-32h64v160h-64V448z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-folder-ops.svg
// module id = uHRi
// module chunks = 396